module.exports = __webpack_public_path__ + "media/images/gifts/open_end/sug_aberto_8-bea186826b1c8f530ea38dea37426675.jpg";